<template>
  <!-- <div>
    <div
      class="d-flex justify-space-between align-center pr-3 pl-3"
      style="height: 70px;"
    >
      <div>
        <v-img
          :src="companyLogo"
          max-width="150px"
          max-height="100px"
          width="100%"
          height="100%"
          contain
        />
      </div>

      <div>
        <span style="font-size: 32px; white-space: nowrap;">{{ documentName }}</span>
      </div>

      <div>
        <v-row>
          <v-col
            cols="auto"
            class="pt-0 pb-0"
          >
            <span>Signed by</span>
          </v-col>
          <v-col
            cols="auto"
            class="pt-0 pb-0"
            v-if="signedSignees.length > 1"
          >
            <v-row
              v-for="i in 2"
              :key="i"
            >
              <v-col
                class="pa-0"
              >
                <span>{{ signedSignees[i - 1].signedByName }} on {{ signedSignees[i - 1].signedDate }}</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="auto"
            class="pt-0 pb-0 pl-0"
            v-else-if="signedSignees.length === 1 && signedSignees[0]"
          >
            <span>{{ signedSignees[0].signedByName }} on {{ signedSignees[0].signedDate }}</span>
          </v-col>
          <v-col
            cols="auto"
            class="pb-0 pr-1 pl-1"
            style="padding-top: 22px;"
            v-if="signedSignees.length > 2"
          >
            <v-menu>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="rgba(0,0,0,0.7)"
                >
                  mdi-chevron-down
                </v-icon>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in signedSignees"
                  :key="index"
                >
                  <v-list-item-title>{{ item.signedByName }} on {{ item.signedDate }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </div>
    </div>
    <prompt-dialog
      v-show="false"
      ref="promptDialog"
    />
  </div> -->
  <v-row
    :style="`background-color: white; max-height: ${isView ? '70px' : '100px'}; min-height: ${isView ? '70px' : '100px'};`"
    class="align-center"
  >
    <v-col
      :class="isView ? 'pt-4 pl-5' : 'pt-0 pl-5'"
      cols="auto"
      style="width: 200px !important;"
    >
      <v-img
        :src="companyLogo"
        max-width="150px"
        max-height="100px"
        width="100%"
        height="100%"
        contain
      />
    </v-col>
    <v-spacer />
    <v-col
      cols="auto"
      :class="isView ? 'pt-4' : 'pt-0'"
    >
      <span style="font-size: 32px; white-space: nowrap;">{{ documentName }}</span>
    </v-col>
    <v-spacer />
    <v-col
      cols="auto"
      v-if="showFinish"
      class="pr-5 text-right pt-0"
      style="width: 200px !important;"
    >
      <v-btn
        color="success"
        :disabled="disabledFinish"
        @click="handleUpload"
      >
        finish
      </v-btn>
    </v-col>
    <v-col
      cols="auto"
      v-else
      class="text-right pr-5"
    >
      <v-row>
        <v-col
          cols="auto"
          class="pt-0 pb-0"
        >
          <span>Signed by</span>
        </v-col>
        <v-col
          cols="auto"
          class="pb-0"
          v-if="signedSignees.length > 1"
        >
          <v-row
            v-for="i in 2"
            :key="i"
          >
            <v-col
              class="pa-0"
            >
              <span>{{ signedSignees[i - 1].signedByName }} on {{ signedSignees[i - 1].signedDate }}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="auto"
          class="pt-0 pb-0 pl-0"
          v-else-if="signedSignees.length === 1 && signedSignees[0]"
        >
          <span>{{ signedSignees[0].signedByName }} on {{ signedSignees[0].signedDate }}</span>
        </v-col>
        <v-col
          cols="auto"
          class="pb-0 pr-1 pl-1"
          style="padding-top: 22px;"
          v-if="signedSignees.length > 2"
        >
          <v-menu>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                color="rgba(0,0,0,0.7)"
              >
                mdi-chevron-down
              </v-icon>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in signedSignees"
                :key="index"
              >
                <v-list-item-title>{{ item.signedByName }} on {{ item.signedDate }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-col>
    <prompt-dialog
      v-show="false"
      ref="promptDialog"
    />
  </v-row>
</template>

<script>
import PromptDialog from '@/components/PromptDialog.vue';
import moment from 'moment';
import Bus from '@/bus';

export default {
  name: 'PdfHeader',
  props: {
    disabledFinish: {
      type: Boolean,
    },
    signedPdf: {},
    documentName: {
      type: String,
      default: '',
    },
    signedPdfList: {
      type: Array,
    },
    signeeOrderType: {
      type: Number,
      default: 1,
    },
    token: {
      type: String,
      default: '',
    },
    showFinish: {
      type: Boolean,
      default: true,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    environment: {
      type: String,
      default: '',
    },
    signedDate: {
      type: String,
      default: '',
    },
    signeeName: {
      type: String,
      default: '',
    },
    signedSignees: {
      type: Array,
      default: () => [],
    },
    companyLogo: {
      type: String,
      default: '',
    },
    moduleId: {
      type: Number,
      default: null,
    },
  },
  components: { PromptDialog },
  computed: {
    signedOnDate() {
      if (this.signedDate) {
        return moment(this.signedDate, 'YYYY-MM-DDTHH:mm:ss').format(
          'DD MMM YYYY HH:mm A'
        );
      }
      return '';
    },
  },
  methods: {
    async handleUpload(isConfirm = true) {
        if(isConfirm)
        {
          const confirm = await this.$refs.promptDialog.open({
            message: 'To ensure that your submission is complete and accurate, please confirm that you are both signing and submitting this document',
          });
          if (!confirm) return;
        }
        Bus.$emit('loading');
        let busResult = new Promise((resolve, reject) => {
          Bus.$emit('submitEnvelopePlacements', resolve, reject);
        });
        busResult
          .then(async () => {
            try {
              const dataToken = { Token: this.token };
              const signedEnvelopesResponse = await this.$api.post(
                `sign-pdf/envelopes/envelopes-signed`,
                dataToken
              );
              if (signedEnvelopesResponse.data === true) {
                for (var sP of this.signedPdfList) {
                  let signPdf = btoa(
                    sP.pdf.reduce(
                      (data, byte) => data + String.fromCharCode(byte),
                      ''
                    )
                  );
                  const data = `data:application/pdf;base64,${signPdf}`;
                  let formData = new FormData();
                  const pdf = await this.dataURLtoFile(data, name);
                  formData.append('FileContent', pdf);
                  formData.append('Guid', this.token);
                  formData.append('DocumentId', sP.documentId);

                  this.$api.setSxEnvironment(this.environment);
                  const res = await this.$api.post(
                    `sign-pdf/envelopes/upload`,
                    formData,
                    {
                      headers: {
                        'Content-Type': 'multipart/form-data',
                      },
                    }
                  );
                  if (res.status !== 200) {Bus.$emit('loading'); return;} 
                }
                const res = await this.$api.post(
                  `sign-pdf/envelopes/email-envelopes`,
                  dataToken
                );
                if(!res) {
                  Bus.$emit('alert', 'error', err);
                  Bus.$emit('loading');
                  return;
                }
              } else {
                if (this.signeeOrderType === 2) {
                  const res = await this.$api.post(
                    `sign-pdf/envelopes/email-envelopes-order`,
                    dataToken
                  );
                  if(!res) {
                  Bus.$emit('alert', 'error', err);
                  Bus.$emit('loading');
                  return;
                }
                }
              }
              Bus.$emit('loading');
              var token = this.token;
              var environment = this.environment;
              const query = { environment, token };
              if(this.moduleId) query.redirect = this.moduleId;
              this.$router.push({
                path: '/sign-pdf/view',
                query: query,
              });
            } catch (error) {
              console.log(error);
              Bus.$emit('loading');
              let errorMessage = error;
              if (
                error.response &&
                error.response.data &&
                error.response.data.message
              ) {
                if (error.response.data.message) {
                  errorMessage = error.response.data.message;
                }
              }

              this.isError = true;
              this.message = errorMessage;
            }
          })
          .catch((err) => {
            Bus.$emit('alert', 'error', err);
            //this.$refs.snackbar.showWarning(err);
          });
    },

    dataURLtoFile(data, name) {
      var arr = data.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], name + '.pdf', { type: mime });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
